import React from 'react';
import PropTypes from 'prop-types';
import { ContentItemFragment } from 'app/graphql/__generated__/types/contento';
import ContentList from '../../ui-components/ContentList/ContentList';
import {
    createListTrackingOnClick,
    createTrackingOnItemImpression,
} from '../../utils/statistics/clientStatistics';

const SLIDABLELIST_ID = 'slidable-vtp';

type Props = {
    listContent: Array<ContentItemFragment>;
    headerText: string;
    listTracking: { listId: string; listType: string };
};

const SimilarVideoContent = ({ listContent, headerText, listTracking }: Props) => {
    if (!listContent) {
        return null;
    }

    const onItemClick = createListTrackingOnClick(listTracking);
    const onItemImpression = createTrackingOnItemImpression(listTracking);

    return (
        <ContentList
            id={SLIDABLELIST_ID}
            items={listContent}
            headerText={headerText}
            onItemClick={onItemClick}
            onItemImpression={onItemImpression}
            regTestSpec="video-page-similar-content"
            expandable
        />
    );
};

SimilarVideoContent.propTypes = {
    listContent: PropTypes.object,
    headerText: PropTypes.string,
    listTracking: PropTypes.object,
};

export default SimilarVideoContent;
